
import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';

export const EducationalSection = () => {
  const { language } = useLanguage();
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="bg-white rounded-lg shadow-md p-8"
    >
      <h2 className="text-2xl font-bold mb-6 text-center text-gray-900">
        {language === 'de' ? 'Die richtige Hundeschule finden' : 'Finding the Right Dog School'}
      </h2>
      
      <div className="space-y-6">
        <div>
          <h3 className="text-xl font-semibold mb-2 text-gray-800">
            {language === 'de' ? 'Warum Hundetraining wichtig ist' : 'Why Dog Training Matters'}
          </h3>
          <p className="text-gray-600 leading-relaxed">
            {language === 'de' 
              ? 'Ein gut trainierter Hund ist ein glücklicher Hund. Professionelles Training fördert nicht nur Gehorsam, sondern stärkt auch die Bindung zwischen Ihnen und Ihrem Vierbeiner. Es hilft, Verhaltensprobleme zu vermeiden und sorgt für ein harmonisches Zusammenleben.'
              : 'A well-trained dog is a happy dog. Professional training not only promotes obedience but also strengthens the bond between you and your four-legged friend. It helps prevent behavioral problems and ensures harmonious coexistence.'}
          </p>
        </div>
        
        <div>
          <h3 className="text-xl font-semibold mb-2 text-gray-800">
            {language === 'de' ? 'Worauf Sie bei der Auswahl einer Hundeschule achten sollten' : 'What to Look For When Choosing a Dog School'}
          </h3>
          <ul className="list-disc pl-5 space-y-2 text-gray-600">
            <li>
              {language === 'de' 
                ? 'Qualifikationen der Trainer: Achten Sie auf professionelle Zertifizierungen und Erfahrung.'
                : 'Trainer qualifications: Look for professional certifications and experience.'}
            </li>
            <li>
              {language === 'de' 
                ? 'Trainingsmethoden: Moderne Hundeschulen setzen auf positive Verstärkung statt auf Bestrafung.'
                : 'Training methods: Modern dog schools focus on positive reinforcement rather than punishment.'}
            </li>
            <li>
              {language === 'de' 
                ? 'Gruppengröße: Kleinere Gruppen ermöglichen eine individuellere Betreuung.'
                : 'Group size: Smaller groups allow for more individualized attention.'}
            </li>
            <li>
              {language === 'de' 
                ? 'Kursangebot: Verschiedene Kurse für unterschiedliche Alters- und Erfahrungsstufen.'
                : 'Course offerings: Various courses for different age and experience levels.'}
            </li>
            <li>
              {language === 'de' 
                ? 'Einrichtungen: Saubere, sichere Trainingsumgebung mit ausreichend Platz.'
                : 'Facilities: Clean, safe training environment with adequate space.'}
            </li>
            <li>
              {language === 'de' 
                ? 'Bewertungen: Erfahrungsberichte anderer Hundehalter können wertvolle Einblicke geben.'
                : 'Reviews: Testimonials from other dog owners can provide valuable insights.'}
            </li>
          </ul>
        </div>
        
        <div>
          <h3 className="text-xl font-semibold mb-2 text-gray-800">
            {language === 'de' ? 'Der erste Besuch' : 'The First Visit'}
          </h3>
          <p className="text-gray-600 leading-relaxed">
            {language === 'de' 
              ? 'Viele Hundeschulen bieten kostenlose Probestunden an. Nutzen Sie diese Gelegenheit, um die Atmosphäre zu erleben und zu sehen, wie Ihr Hund auf die Umgebung und den Trainer reagiert. Eine gute Hundeschule sollte Ihnen und Ihrem Hund ein angenehmes Gefühl vermitteln.'
              : 'Many dog schools offer free trial lessons. Take advantage of this opportunity to experience the atmosphere and see how your dog responds to the environment and the trainer. A good dog school should make both you and your dog feel comfortable.'}
          </p>
        </div>
      </div>
    </motion.div>
  );
};
